import { Route, Routes } from "react-router-dom";
import PriceListDetailPage from "./DetailPage";
import PriceLists from "./PriceLists";

const PriceListRoutes = () => {
  return (
    <Routes>
      <Route index element={<PriceLists />} />
      <Route path=":id" element={<PriceListDetailPage />} />
    </Routes>
  );
};

export default PriceListRoutes;
